/*
  What people do on the site, for Microsoft Clarity (heatmaps, recordings) and Shopify's customer
  events. window.vxTrack(name, tags) records one moment, e.g. "order_step_3_needs":
    - a Clarity custom event (use it to build funnels and to filter recordings), and a Clarity tag
      so a recording can be found by how far they got;
    - a Shopify customer event "vortex_<name>", for any pixel you add later (GA4, Meta).
  Each moment is counted once per page view. Nothing typed into a form is sent.
  Forms other than the team order form are tracked here on their own: started, then submitted.
*/
(() => {
  const seen = new Set();
  const clarity = (...a) => { try { if (typeof window.clarity === 'function') window.clarity(...a); } catch (e) { /* blocked */ } };
  window.vxTrack = (name, tags = {}) => {
    if (!name || seen.has(name)) return;
    seen.add(name);
    clarity('event', name);
    Object.entries(tags).forEach(([k, v]) => clarity('set', k, String(v)));
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(`vortex_${name}`, tags);
    } catch (e) { /* optional */ }
  };

  const slug = (s) => String(s || 'form').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 40);
  const nameOf = (form) => {
    const type = (form.querySelector('[name="form_type"]') || {}).value || '';
    if (form.dataset.formName) return form.dataset.formName;
    if (type === 'customer') return 'newsletter';
    if (type === 'contact') return 'contact';
    return form.id || 'form';
  };
  const skip = (form) => !(form instanceof HTMLFormElement)
    || form.matches('[data-kit-form], [role="search"], [action*="/search"], [action*="/cart"], [action*="/account"]');

  // other forms: first thing typed, and sent
  document.addEventListener('input', (e) => {
    const form = e.target && e.target.form;
    if (!form || skip(form)) return;
    window.vxTrack(`${slug(nameOf(form))}_form_started`);
  }, true);
  document.addEventListener('submit', (e) => {
    if (skip(e.target)) return;
    window.vxTrack(`${slug(nameOf(e.target))}_form_submitted`);
  }, true);

  // the team order form and the kit builder: seen (scrolled into view)
  const onSeen = (sel, name) => {
    const el = document.querySelector(sel);
    if (!el || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((en) => en.isIntersecting)) { window.vxTrack(name); io.disconnect(); }
    }, { threshold: 0.25 });
    io.observe(el);
  };
  const ready = () => {
    onSeen('[data-kit-form]', 'order_form_seen');
    onSeen('[data-kit-designer], .kd', 'kit_builder_seen');
    onSeen('[data-locker]', 'locker_room_seen');
    // first real tap or click inside the kit builder (not just scrolling past it)
    const kit = document.querySelector('.kd');
    if (kit) kit.addEventListener('pointerdown', () => window.vxTrack('kit_builder_used'), { once: true });
    const order = document.querySelector('[data-kit-form]');
    if (order) order.addEventListener('input', () => window.vxTrack('order_form_started', { order_step: 1 }), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
